export default "__VITE_ASSET__Dsel340C__"